/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import { State, SelectingState } from '../menu-list.slice';

export default function updateSearch(state: State, action: PayloadAction<string>): void {
  state.search = action.payload;
  state.page = 1;
  state.selected = [];
  state.selectingState = SelectingState.simple;
}
